import { Component, computed, DestroyRef, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { SmartQuoteService } from 'src/app/core/services/smartquote/smartquote.service'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { SmartQuoteFilter } from 'src/app/shared/interfaces/smartquote/smart-quote-filter.interface'
import { SmartQuoteListItem } from 'src/app/shared/interfaces/smartquote/smart-quote-list-item.interface'
import { SmartquoteTableComponent } from './components/smartquote-table/smartquote-table.component'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { SmartquoteSearchComponent } from './components/smartquote-search/smartquote-search.component'
import { SmartquoteHelperService } from './smartquote-helper.service'
import { EmptyComponent } from 'src/app/shared/components/empty/empty.component'
import { NgbModal, NgbOffcanvas, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap'
import { PaginationDetailComponent } from 'src/app/shared/components/pagination-detail/pagination-detail.component'
import { Router, RouterModule } from '@angular/router'
import { NgApexchartsModule } from 'ng-apexcharts'
import { rxResource, takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { PageTitleComponent } from 'src/app/shared/components/page-title/page-title.component'
import { PageActionBarComponent } from 'src/app/shared/components/page-action-bar/page-action-bar.component'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { CustomerSearchPulloutComponent } from 'src/app/shared/components/customer/customer-search-pullout/customer-search-pullout.component'
import { CustomerListItem } from 'src/app/shared/interfaces/customer/customer-list-item.interface'
import { AppStore } from 'src/app/core/app.store'

@Component({
    selector: 'sf-smartquotes',
    imports: [
        RouterModule,
        NgbPaginationModule,
        NgApexchartsModule,
        CardComponent,
        ButtonComponent,
        SmartquoteTableComponent,
        SmartquoteSearchComponent,
        EmptyComponent,
        PaginationDetailComponent,
        PageTitleComponent,
        PageActionBarComponent,
    ],
    templateUrl: './smartquotes.component.html',
    styleUrls: ['./smartquotes.component.scss'],
})
export class SmartquotesComponent {
    private smartQuoteService = inject(SmartQuoteService)
    public smartQuoteHelperService = inject(SmartquoteHelperService)
    #destroyRef = inject(DestroyRef)
    #router = inject(Router)
    #ngbOffcanvas = inject(NgbOffcanvas)

    smartQuotes$!: Observable<PaginatedList<SmartQuoteListItem>>

    #smartquotesResource = rxResource({
        params: () => this.smartQuoteHelperService.filter(),
        stream: ({ params }) => this.smartQuoteService.getSmartQuotesPaged(params),
    })

    smartQuotesPaged = computed(() => this.#smartquotesResource.value())

    onPageChange(pageNumber: number): void {
        this.smartQuoteHelperService.updateFilter({ ...this.smartQuoteHelperService.filter(), pageNumber })
    }

    onFilterChange(filter: SmartQuoteFilter): void {
        this.smartQuoteHelperService.updateFilter({ ...filter, pageNumber: 1 })
    }

    openCustomerPullout(): void {
        const ref = this.#ngbOffcanvas.open(CustomerSearchPulloutComponent, { position: 'end', scroll: true })
        ref.componentInstance.description = 'Select a customer to create a new SmartQuote for'
        ref.componentInstance.onSelectedCustomer
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe((customer: CustomerListItem) => {
                // this.#router.navigateByUrl('/smartquotes/0', )
                this.#router.navigate(['/smartquote'], { queryParams: { customerId: customer.id } })
            })
    }
}
